<template>
  <v-dialog v-model="dialogOpen" width="500" @click:outside="close">
    <v-card v-if="linkAllowed">
      <v-card-title>
        <template>Link as COT</template>
      </v-card-title>

      <v-card-text>
        <template>Are you sure you?</template>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <template>
          <v-btn color="primary" small @click="submit" :disabled="getIsCreateLinkedProductLoading" :loading="getIsCreateLinkedProductLoading">CONFIRM</v-btn>
        </template>

        <v-btn color="primary" small outlined @click="close" :disabled="getIsCreateLinkedProductLoading">
          <template>CANCEL</template>
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-else>
      <v-card-title>Success!</v-card-title>

      <v-card-text>
        Linked product <a :href="`/products/${getLinkedTypeProduct.product_2_id}`">{{getLinkedTypeProduct.product_2_id}}</a> has been created!
      </v-card-text>

      <v-card-actions class="d-flex justify-end">
        <v-btn color="primary" small outlined @click="close">CLOSE</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex';
  
  export default {
    props: ['dialogOpen'],

    computed: {
      ...mapState('products', ['currentProduct']),
      ...mapGetters("productLinks", ["getLinkedProductByType", "getIsCreateLinkedProductLoading"]),

      linkAllowed() {
        const link = this.getLinkedProductByType('COT');
        if(!Object.keys(link).length) return true;
        if(link.product_2_id === parseInt(this.$route.params.id)) return true;
        if(link.product_1_id && link.product_2_id && (link.product_1_id === parseInt(this.$route.params.id))) return false;
        return true;
      },

      getLinkedTypeProduct() {
        return this.getLinkedProductByType('COT');
      },
    },

    methods: {
      ...mapActions('productLinks', ['createLinkedProduct']),

      async submit() {
        await this.createLinkedProduct({ lead_id: this.currentProduct.id, payload: { link_type: "COT" } });
      },

      close() {
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
